import React, {createContext, useCallback, useContext} from 'react';
import {assert} from 'assert-ts';

type CollapseContextType = {
  enabled: boolean;
  isCollapsed: boolean;
  toggleCollapse: () => void;
};

export const CollapseContext = createContext<CollapseContextType>({
  enabled: false,
  isCollapsed: true,
  toggleCollapse: () => undefined,
});

export const useCollapseContextProviderValue = (
  enabled?: boolean,
): CollapseContextType => {
  const [isCollapsed, setIsCollapsed] = React.useState(true);

  const toggleCollapse = useCallback(() => {
    if (enabled) {
      setIsCollapsed(!isCollapsed);
    }
  }, [enabled, isCollapsed]);

  return {
    enabled: !!enabled,
    isCollapsed,
    toggleCollapse,
  };
};

export const useCollapseContext = () => {
  return assert(
    useContext(CollapseContext),
    'CollapseContext: context expected',
  );
};
